Postlogin = (function (self) {
    self.LessonsDocuments = {};
    const me = self.LessonsDocuments;

    me.init = function () {
        gsap.registerPlugin(ScrollTrigger);
        setTimeout(() => {
            setupAnimations();
        }, 3000);

        const columns = [
            {
                title: 'Name',
                field: 'name',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Grades',
                field: 'grade_band',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
        ];

        const $documentTable = $('#document-table');
        $documentTable.bootstrapTable({
            formatNoMatches() {
                return 'No lessons to show';
            },
            classes: 'table table-hover table-condensed',
            detailView: true,
            detailFormatter(index, row) {
                if (!row) {
                    return null;
                }

                if (!row.has_access) {
                    return `<p class="inquiry">This lesson is not available with your current subscription.</p>
                        <p class="inquiry">If you are interested in upgrading your subscription, please reach out to your account manager.</p>`;
                }

                return `
                    <ul class="file-list">
                        ${row.documents
                    .map(
                        (document) => `
                            <li>
                                <a href="${document.path}" target="_blank">
                                    <i class="fa-regular fa-file-pdf" aria-hidden="true"></i>
                                    <span>${document.title}</span>
                                    <i class="fa fa-cloud-download" aria-hidden="true"></i>
                                </a>
                            </li>
                        `,
                    )
                    .join('')}
                    </ul>
                `;
            },
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'lesson_id',
            search: false,
            sortName: 'name',
            sortOrder: 'asc',
            searchAlign: 'right',
            url: '/lessons/documents/json',
            queryParamsType: 'other',
            queryParams(params) {
                const lessonParams = {};
                lessonParams.search_term = params.searchText;
                lessonParams.doc_type = 'activity';

                return lessonParams;
            },
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                return formattedResult;
            },
            columns,
            detailViewByClick: true,
        });

        const $outlineTable = $('#outline-table');
        $outlineTable.bootstrapTable({
            formatNoMatches() {
                return 'No lessons to show';
            },
            classes: 'table table-hover table-condensed',
            detailView: true,
            detailFormatter(index, row) {
                if (!row) {
                    return null;
                }

                if (!row.has_access) {
                    return `<p class="inquiry">This lesson is not available with your current subscription.</p>
                        <p class="inquiry">If you are interested in upgrading your subscription, please reach out to your account manager.</p>`;
                }

                return `
                    <ul class="file-list">
                        ${row.documents
                    .map(
                        (document) => `
                            <li>
                                <a href="${document.path}" target="_blank">
                                    <i class="fa-regular fa-file-pdf" aria-hidden="true"></i>
                                    <span>${document.title}</span>
                                    <i class="fa fa-cloud-download" aria-hidden="true"></i>
                                </a>
                            </li>
                        `,
                    )
                    .join('')}
                    </ul>
                `;
            },
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'lesson_id',
            search: false,
            sortName: 'name',
            sortOrder: 'asc',
            searchAlign: 'right',
            url: '/lessons/documents/json',
            queryParamsType: 'other',
            queryParams(params) {
                const lessonParams = {};
                lessonParams.search_term = params.searchText;
                lessonParams.doc_type = 'outline';

                return lessonParams;
            },
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                return formattedResult;
            },
            columns,
            detailViewByClick: true,
        });
    };

    const setupAnimations = function () {
        const boltron = $('svg#boltron');
        const boltronBrows = boltron.find('#left-brows');
        const boltronEye = boltron.find('#eye-center');
        const mummy = $('#mummy');
        const mummyPupils = mummy.find('#pupil1, #pupil2');
        const mummySocket1 = mummy.find('#socket1');
        const mummySocket2 = mummy.find('#socket2');

        // this is boltron sliding in from the right
        gsap.to(boltron, {
            x: -140,
            rotation: '-20',
            scrollTrigger: {
                trigger: '.container',
                start: '20%',
                end: '50%',
                scrub: true,
                // markers: true,
            },
        });

        // boltrons brows raising once
        gsap.to(boltronBrows, {
            scrollTrigger: {
                trigger: '.container',
                start: '50%',
                toggleActions: 'restart reset reset reverse',
            },
            y: -10,
            x: -10,
            repeat: 1,
            duration: 1,
            yoyo: true,
            ease: 'power2',
        });

        // eye blink open - repeats finite
        gsap.to(boltronEye, {
            scrollTrigger: {
                trigger: '.container',
                start: 'center top',
                toggleActions: 'play none none pause',
            },
            scale: 1,
            duration: 0.1,
            svgOrigin: '177 203',
            repeat: 5,
            repeatDelay: 5,
            delay: 2.2,
            ease: Power1.out,
        });

        // eye blink close - repeats finite
        gsap.to(boltronEye, {
            scrollTrigger: {
                trigger: '.container',
                start: 'center top',
                toggleActions: 'play none none pause',
            },
            scale: 0,
            delay: 2,
            duration: 0.05,
            svgOrigin: '177 203',
            repeat: 5,
            repeatDelay: 5,
        });

        // if this starts to interfere the numbers can be adjusted
        // switched to percentage-based sizes w/ @queries
        gsap.to(mummy, {
            x: '+=100',
            rotation: '25',
            scrollTrigger: {
                start: '0',
                end: '50%',
                scrub: true,
            },
        });

        const eyeFollow = (ev) => {
            ev.stopPropagation();

            const socket1 = mummySocket1[0].getBBox();
            const socket2 = mummySocket2[0].getBBox();
            const pupilOrigin1 = `${socket1.x} ${socket1.y}`;
            const pupilOrigin2 = `${socket2.x} ${socket2.y}`;
            const pupil1 = mummyPupils[0].getBoundingClientRect();
            const pupil2 = mummyPupils[1].getBoundingClientRect();

            const leftPupil = {
                offsetX: (Math.atan((ev.clientX - pupil1.left) * 0.01) / Math.PI) * socket1.width,
                offsetY: (Math.atan((ev.clientY - pupil1.top) * 0.01) / Math.PI) * socket1.height,
            };

            const rightPupil = {
                offsetX: (Math.atan((ev.clientX - pupil2.left) * 0.01) / Math.PI) * socket2.width,
                offsetY: (Math.atan((ev.clientY - pupil2.top) * 0.01) / Math.PI) * socket2.height,
            };

            gsap.to(mummyPupils[0], {
                duration: 0.1,
                x: leftPupil.offsetX,
                y: leftPupil.offsetY,

                svgOrigin: pupilOrigin1,
            });

            gsap.to(mummyPupils[1], {
                duration: 0.1,
                x: rightPupil.offsetX,
                y: rightPupil.offsetY,
                svgOrigin: pupilOrigin2,
            });
        };

        $('.container')[0].addEventListener('mousemove', eyeFollow);
    };

    return self;
}(Postlogin || {}));
